import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { getS3ImageUrl } from '../utils/imageUtils';

const FoodTypeCard = ({ foodType, onClick }) => {
    const imageName = foodType.id;
    const foodTypeImageUrl = getS3ImageUrl(`images/foodTypeImages/${imageName}.jpg`);

    useEffect(() => {
        // console.log('looking for image:', `/images/foodTypeImages/${foodType.id}.jpg`);
    }, []);

    // If onClick is provided, use it instead of Link
    if (onClick) {
        return (
            <div 
                onClick={() => onClick(foodType)}
                className="diet-card"
                style={{ cursor: 'pointer' }}
            >
                <img
                    className="diet-card-image"
                    src={foodTypeImageUrl}
                    alt={foodType.name}
                />
                <div className="diet-card-content">
                    <h3 className="recipe-filter-name">{foodType.name}</h3>
                </div>
            </div>
        );
    }

    return (
        <Link 
            to={`/food-type/${foodType.name}`} 
            state={{ foodType: foodType}} 
            className="diet-card"
        >
            <img
                className="diet-card-image"
                src={foodTypeImageUrl}
                alt={foodType.name}
            />
            <div className="diet-card-content">
                <h3 className="recipe-filter-name">{foodType.name}</h3>
            </div>
        </Link>
    );
};

export default FoodTypeCard;